function initSmgStrugglesSwiper(root) {
  var el = root.querySelector('[data-smg-struggles-swiper]');
  if (!el || typeof Swiper === 'undefined') return;
  if (el.swiper) el.swiper.destroy(true, true);

  new Swiper(el, {
    slidesPerView: 1,
    centeredSlides: true,
    spaceBetween: 16,
    navigation: {
      nextEl: root.querySelector('.smg-struggles__nav--next'),
      prevEl: root.querySelector('.smg-struggles__nav--prev')
    },
    a11y: {
      prevSlideMessage: 'Previous struggle',
      nextSlideMessage: 'Next struggle'
    },
    breakpoints: {
      568: {
        slidesPerView: 2,
        centeredSlides: false,
        spaceBetween: 16
      },
      768: {
        slidesPerView: 2,
        centeredSlides: false,
        spaceBetween: 16
      },
      992: {
        slidesPerView: 'auto',
        enabled: false
      }
    }
  });
}

function initAllSmgStruggles(scope) {
  var sections = (scope || document).querySelectorAll('.smg-struggles');
  sections.forEach(function (section) {
    initSmgStrugglesSwiper(section);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    initAllSmgStruggles(document);
  });
} else {
  initAllSmgStruggles(document);
}

document.addEventListener('shopify:section:load', function (e) {
  initAllSmgStruggles(e.target);
});
